import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { WalletService } from '@app/@shared/services/wallet.service';
import { Credentials, CredentialsService } from '@app/auth/credentials.service';
import { BrandingService } from '@shared/services/branding.service';

@Component({
  selector: 'app-header-home',
  templateUrl: './header-home.component.html',
  styleUrl: './header-home.component.scss',
})
export class HeaderHomeComponent {
  @Input() walletS!: WalletService;
  @Input() isLoading = false;
  private _credentials: Credentials | null = null;
  @Input()
  set credentials(value: Credentials | null) {
    this._credentials = value;
  }
  get credentials(): Credentials | null {
    return this._credentials || this.credentialsService.credentials;
  }
  constructor(
    private route: Router,
    public brandingService: BrandingService,
    private credentialsService: CredentialsService
  ) {}
  navigateToHome() {
    this.route.navigate(['/home'], { queryParamsHandling: 'preserve' });
  }
}
